import React, { useState } from "react";

import ThermostatControl from "./ThermostatControl"

import "./controls.scss"

 const Controls = (props) => {
	return (
		<div className="controls-block" id = {props.equipment.equipment_id}>
			{
                props.equipment && props.equipment.type == "Thermostat" ?
                    <ThermostatControl equipment={props.equipment} controlCallback={props.controlCallback} />
			    : null 
            }
		</div>
	)
}

export default Controls;